import { get, del } from '../../utils/api'
import { AxiosResponse } from 'axios'

export const fetchLessonsList = (id: string): Promise<AxiosResponse> =>
  get(`/courses/courses/${id}/lessons`, {
    include: 'moduleLessons.module',
  })

export const removeLesson = (id: string): Promise<AxiosResponse> =>
  del(`/courses/lessons/${id}`)
